import { render, staticRenderFns } from "./QueueButton.vue?vue&type=template&id=40e988d6&scoped=true&"
import script from "./QueueButton.vue?vue&type=script&lang=ts&"
export * from "./QueueButton.vue?vue&type=script&lang=ts&"
import style0 from "./QueueButton.vue?vue&type=style&index=0&id=40e988d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e988d6",
  null
  
)

export default component.exports